import { actionTextColor } from "../../utils/themeContrast";
import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext, ActionContext } from "../../contexts/Context";
import { BsCreditCard2BackFill, BsCashStack } from "react-icons/bs";
import { MdCardMembership } from "react-icons/md";
import { lightTint, readableText } from "../../utils/themeContrast";
import CustomerPaymentTerm from "../customerComponents/CustomerPaymentTerm";
const Modal = ({
  show,
  setShow,
  lanIndex,
  payType,
  setPayType,
  confirmPTCheckOut,
  total,
  payAtCounter
}) => {
  //State
  const displayShow = show ? "flex" : "none";
  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);
  const [warningMsg, setWarningMsg] = useState(false);
  const [paymentTermChecked, setPaymentTermChecked] = useState(false);
  const [showPaymentTerm, setShowPaymentTerm] = useState(false);
  const [paymentTermWarning, setPaymentTermWarning] = useState(false);
  const { isOnlinePayMinConsumption, onlinePayMinConsumptionVal, paymentSelectionMessage, isInRoom, advocadoStoreCredit, haveToPayOnline, hasFomoPay, hasPayment, displayPaymentTerm } = React.useContext(UserContext);
  const { addPayType } = React.useContext(ActionContext);
  const isEnabled = (value) => value === true || value === "true" || value === 1 || value === "1";
  const isOnlinePaymentSelected = payType == 0 || payType == 3;
  const requiresPaymentTerm = isEnabled(hasPayment) && isEnabled(displayPaymentTerm) && isOnlinePaymentSelected;
  const paymentMethodCount = 1 +
    ((payAtCounter || !haveToPayOnline) ? 1 : 0) +
    (advocadoStoreCredit ? 1 : 0) +
    (hasFomoPay ? 1 : 0);
  const usePaymentGrid = paymentMethodCount > 2;

  useEffect(() => {
    if (!show) {
      setPaymentTermChecked(false);
      setPaymentTermWarning(false);
      setShowPaymentTerm(false);
    }
  }, [show]);

  const selectPayType = (selectedPayType) => {
    setPayType(selectedPayType);
    setWarningMsg(false);
    setPaymentTermWarning(false);
    if (selectedPayType != 0 && selectedPayType != 3) {
      setPaymentTermChecked(false);
    }
    addPayType(selectedPayType);
  };

  const modalButton = () => {
    return (
      <ModalButtonContainer>
        <ModalConfirmButton type="button"
          themeContext={themeContext}
          backgroundColor="#d9d9d9"
          color="#747474"
          onClick={() => {
            setShow(false);
          }}
        >
          <ModalText
            fontSize={16}
            fontWeight={600}
            color="#4c4c4c"
          >
            {languageContext[lanIndex].cancel}
          </ModalText>
        </ModalConfirmButton>
        <ModalConfirmButton type="button"
          primary
          color="#fff"
          backgroundColor={themeContext.fontPrimary}
          themeContext={themeContext}
          onClick={() => {
            if (payType == 0 && isOnlinePayMinConsumption && total < onlinePayMinConsumptionVal) return;
            if (payType == -1) {
              setWarningMsg(true);
              return;
            }
            if (requiresPaymentTerm && !paymentTermChecked) {
              setPaymentTermWarning(true);
              return;
            }
            setShow(false);
            confirmPTCheckOut(payType);
          }}
        >
          <ModalText
            fontSize={16}
            fontWeight={600}
            color={"#fff"}
          >
            {languageContext[lanIndex].ok}
          </ModalText>
        </ModalConfirmButton>
      </ModalButtonContainer>
    );
  }

  return (
    <ModalContainer display={displayShow}>
      <ModalMain themeContext={themeContext} role="dialog" aria-modal="true" aria-label={languageContext[lanIndex].pleasePayment}>
        <ModalTitle themeContext={themeContext}>

          {languageContext[lanIndex].pleasePayment}
          {warningMsg &&
            <div style={{ color: "rgb(207, 0, 13)", fontSize: 12, lineHeight: "12px", marginTop: 8 }}>
              {languageContext[lanIndex].pleasePayment}
            </div>
          }
          <ModalDiv wrapOptions={usePaymentGrid} style={{ marginTop: 22, fontSize: 16 }}>
            <ModalSpan type="button" wrapOptions={usePaymentGrid} selected={payType == 0} aria-pressed={payType == 0} themeContext={themeContext} onClick={() => { selectPayType(0); }}>
              {payType == 0 ?
                <BsCashStack size={24} /> :
                <BsCashStack size={24} />}
              <div>{hasFomoPay ? languageContext[lanIndex].creditCard : languageContext[lanIndex].payOnline}</div>
            </ModalSpan>
            {(payAtCounter || !haveToPayOnline) &&
              <Line wrapOptions={usePaymentGrid} />
            }
            {(payAtCounter || !haveToPayOnline) &&
              <ModalSpan type="button" wrapOptions={usePaymentGrid} selected={payType == 1} aria-pressed={payType == 1} themeContext={themeContext} onClick={() => { selectPayType(1); }}>
                {payType == 1 ?
                  <BsCreditCard2BackFill size={24} /> :
                  <BsCreditCard2BackFill size={24} />}
                <div>{isInRoom ? languageContext[lanIndex].roomCharge : (payAtCounter ? languageContext[lanIndex].payAtCounterLabel : languageContext[lanIndex].payLater)}</div>
                {paymentSelectionMessage && paymentSelectionMessage != null &&
                  <div style={{ color: "rgb(207, 0, 13)", textAlign: "center", fontSize: 12, lineHeight: "12px", marginTop: 8 }}>{`${paymentSelectionMessage}`}</div>
                }
              </ModalSpan>
            }
            {advocadoStoreCredit &&
              <Line wrapOptions={usePaymentGrid} />
            }
            {advocadoStoreCredit &&
              <ModalSpan type="button" wrapOptions={usePaymentGrid} selected={payType == 2} aria-pressed={payType == 2} themeContext={themeContext} onClick={() => { selectPayType(2); }}>
                {payType == 2 ?
                  <MdCardMembership size={24} /> :
                  <MdCardMembership size={24} />}
                <div>{languageContext[lanIndex].storeCreditLabel}</div>
              </ModalSpan>
            }
            {hasFomoPay &&
              <Line wrapOptions={usePaymentGrid} />
            }
            {hasFomoPay &&
              <ModalSpan type="button" wrapOptions={usePaymentGrid} selected={payType == 3} aria-pressed={payType == 3} themeContext={themeContext} onClick={() => { selectPayType(3); }}>
                {payType == 3 ?
                  <MdCardMembership size={24} /> :
                  <MdCardMembership size={24} />}
                <div>{languageContext[lanIndex].payNowLabel}</div>
              </ModalSpan>
            }
          </ModalDiv>
        </ModalTitle>
        {isOnlinePayMinConsumption && onlinePayMinConsumptionVal > 0 && payType == 0 &&
          <b style={{ fontSize: 13, margin: '10px 0 0 10px' }}>{`${languageContext[lanIndex].minimumConsumptionTip} ${onlinePayMinConsumptionVal}`}</b>
        }
        {requiresPaymentTerm &&
          <PaymentTermWrapper>
            <PaymentTermCheckbox aria-label={languageContext[lanIndex].acknowledgePaymentTerms + " " + languageContext[lanIndex].paymentTermsLabel} themeContext={themeContext}
              type="checkbox"
              checked={paymentTermChecked}
              onChange={(event) => {
                setPaymentTermChecked(event.target.checked);
                setPaymentTermWarning(false);
              }}
            />
            <PaymentTermText>
              {languageContext[lanIndex].acknowledgePaymentTerms}&nbsp;
              <PaymentTermLink themeContext={themeContext} type="button" onClick={() => { setShowPaymentTerm(true); }}>
                {languageContext[lanIndex].paymentTermsLabel}
              </PaymentTermLink>
            </PaymentTermText>
          </PaymentTermWrapper>
        }
        {paymentTermWarning &&
          <PaymentTermWarning>
            {languageContext[lanIndex].paymentTermsWarning}
          </PaymentTermWarning>
        }

        {modalButton()}
      </ModalMain>
      <CustomerPaymentTerm show={showPaymentTerm} setShow={setShowPaymentTerm} />
    </ModalContainer>
  );
};

export default Modal;

const ModalContainer = styled.div`
  display: ${p => p.display}; position: fixed; inset: 0; box-sizing: border-box;
  align-items: center; justify-content: center; padding: 20px;
  background: rgba(0,0,0,.48); z-index: 1100;
`;

const ModalMain = styled.div`
  width: 100%; max-width: 400px; max-height: calc(100dvh - 40px); overflow-y: auto;
  box-sizing: border-box; padding: 20px 18px 18px; border-radius: 18px;
  border: 1px solid rgba(128,128,128,.15); box-shadow: 0 16px 48px rgba(0,0,0,.18);
  background: ${p => p.themeContext.backgroundColor};
  color: ${p => readableText(p.themeContext.backgroundColor, p.themeContext.fontPrimary)};
  font-family: ${p => p.themeContext.fontFamily};
`;
const ModalTitle = styled.div`
  font-size: 16px; font-weight: 700; line-height: 1.4; text-align: left;
`;
const ModalButtonContainer = styled.div`
  display: flex; gap: 8px; margin-top: 20px; width: 100%;
`;

const ModalDiv = styled.div`
  display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; width: 100%;
`;

const Line = styled.span`
  display: none;
`;

const PaymentTermWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin: 14px 0 0 10px;
  line-height: 18px;
`;

const PaymentTermCheckbox = styled.input`
  flex: 0 0 auto; margin: 2px 8px 0 0; accent-color: ${p => p.themeContext.primaryColor};
`;

const PaymentTermText = styled.span`
  color: inherit; font-size: 13px; font-weight: 400;
`;

const PaymentTermLink = styled.button`
  color: ${p => readableText(p.themeContext.backgroundColor, p.themeContext.primaryColor)};
  background: none; border: 0; padding: 0; font: inherit; text-decoration: underline; cursor: pointer;
`;

const PaymentTermWarning = styled.div`
  color: rgb(207, 0, 13);
  font-size: 12px;
  line-height: 14px;
  margin: 6px 0 0 10px;
`;

const ModalSpan = styled.button`
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px;
  min-width: 0; min-height: 100px; padding: 14px 10px; box-sizing: border-box;
  border: 1px solid ${p => lightTint(p.themeContext.primaryColor, p.selected ? .65 : .2)};
  border-radius: 14px;
  background: ${p => p.selected ? lightTint(p.themeContext.primaryColor, .08) : p.themeContext.backgroundColor};
  color: ${p => readableText(p.selected ? lightTint(p.themeContext.primaryColor, .08) : p.themeContext.backgroundColor, p.selected ? p.themeContext.primaryColor : p.themeContext.fontPrimary)};
  font: inherit; font-size: 13px; font-weight: 500; line-height: 1.4; text-align: center; cursor: pointer;
  box-shadow: ${p => p.selected ? 'inset 0 0 0 1px currentColor' : 'none'};
  &:focus-visible { outline: 2px solid ${p => p.themeContext.primaryColor}; outline-offset: 2px; }
`;
const ModalConfirmButton = styled.button`
  flex: 1; min-width: 0; min-height: 44px; padding: 10px 12px; border-radius: 999px;
  border: 1px solid ${p => p.primary ? p.themeContext.primaryColor : lightTint(p.themeContext.primaryColor, .24)};
  background: ${p => p.primary ? p.themeContext.primaryColor : p.themeContext.backgroundColor};
  color: ${p => (p.primary ? actionTextColor(p.themeContext) : readableText(p.themeContext.backgroundColor, p.themeContext.fontPrimary))};
  font: inherit; font-size: 13px; font-weight: 600; cursor: pointer;
  &:focus-visible { outline: 2px solid ${p => p.themeContext.primaryColor}; outline-offset: 2px; }
`;

const ModalText = styled.span`
  color: inherit; font: inherit;
`;
